import React from 'react'

import {
  DateTimeField,
  FieldSpec,
  FulfillmentStatusField,
  OrderStatusField,
  PaginatedTable,
  RelatedLinkedField,
  UnitLocUnitField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  order: {
    id: 'order',
    label: 'Order',
    ordering: 'order__number',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  orderStatus: {
    id: 'order.status',
    label: 'Order Status',
    ordering: 'order__status',
    renderer: OrderStatusField,

  },
  productName: {
    id: 'sku.productName',
    label: 'Product Name',
    ordering: 'sku__product_name',
    renderer: ValueField,
  },
  product: {
    id: 'product',
    label: 'Product',
    ordering: 'product__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  sku: {
    id: 'sku',
    label: 'SKU',
    ordering: 'sku__sku',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  container: {
    id: 'container',
    label: 'Container',
    ordering: 'container__guid',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  batch: {
    id: 'batch',
    label: 'Batch',
    ordering: 'batch__client_uid',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  placedOn: {
    id: 'order.placedOn',
    label: 'Place On',
    ordering: 'order__placed_on',
    renderer: DateTimeField,
  },
  status: {
    id: 'status',
    label: 'Fulfillment Status',
    renderer: FulfillmentStatusField,
  },
  numUnits: {
    id: 'numUnits',
    label: 'Number of Units Ordered',
    ordering: 'num_units',
    renderer: UnitLocUnitField,
  },
  numPicked: {
    id: 'numPicked',
    label: 'Number of Units Picked',
    ordering: 'num_picked',
    renderer: UnitLocUnitField,
  },
  numFulfilled: {
    id: 'numFulfilled',
    label: 'Number of Units Fulfilled',
    ordering: 'num_fulfilled',
    renderer: UnitLocUnitField,
  },
}

export const FreightOrderUnitListTable = (props: ListTableProps) => {
  const { paginator, fields, title = 'Units in Active Freight Orders', exportConfig } = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
